import { SelectItem } from "primeng/api";

enum DocumentType {
    PrescriptionLetter = 1,
    ClinicLetter,
    ReferralLetter,
    TueReport,
    ImagingReport,
    ScreeningReport,
    BloodReport,
    OtherInvestigationReport,
    PerformanceReport,
    AdminReport,
    MedicationSupplementReport,
    MedicalExceptionReport,
    Form,
    Other
}

const DocumentTypeMap: { [key: number]: string } = {};

DocumentTypeMap[DocumentType.PrescriptionLetter] = "Prescription";
DocumentTypeMap[DocumentType.ClinicLetter] = "Clinic Letter";
DocumentTypeMap[DocumentType.ReferralLetter] = "Referral";
DocumentTypeMap[DocumentType.TueReport] = "TUE";
DocumentTypeMap[DocumentType.ImagingReport] = "Imaging Report";
DocumentTypeMap[DocumentType.ScreeningReport] = "Screening Report";
DocumentTypeMap[DocumentType.BloodReport] = "Blood Report";
DocumentTypeMap[DocumentType.OtherInvestigationReport] = "Other Investigation Report";
DocumentTypeMap[DocumentType.PerformanceReport] = "Performance Report";
DocumentTypeMap[DocumentType.AdminReport] = "Admin";
DocumentTypeMap[DocumentType.Other] = "Other";
DocumentTypeMap[DocumentType.MedicationSupplementReport] = "Medication & Supplement Report";
DocumentTypeMap[DocumentType.MedicalExceptionReport] = "Medical Exception Report";
DocumentTypeMap[DocumentType.Form] = "Form";

const createOptions = () =>
    Object.keys(DocumentType)
        .filter(k => !isNaN(+k))
        .map(dt => <SelectItem>{ label: DocumentTypeMap[dt], value: dt });

export { DocumentType, DocumentTypeMap, createOptions };
